var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcOp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H44V44H24C10.7452 44 0 33.2548 0 20V0Z",
    fill: "#FF0420"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5117_22007)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5117_22007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 40C31.9411 40 40 31.9411 40 22C40 12.0589 31.9411 4 22 4C12.0589 4 4 12.0589 4 22C4 31.9411 12.0589 40 22 40Z",
    fill: "#FF0420"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.752 26.7809C15.6792 26.7809 14.8008 26.5289 14.1168 26.0249C13.44 25.5137 13.1016 24.7793 13.1016 23.8361C13.1016 23.6345 13.1232 23.3969 13.1664 23.1089C13.2816 22.4609 13.4472 21.6833 13.6632 20.7689C14.2752 18.2921 15.8592 17.0537 18.408 17.0537C19.0992 17.0537 19.7256 17.1689 20.2728 17.4065C20.82 17.6297 21.252 17.9753 21.5688 18.4361C21.8856 18.8897 22.044 19.4297 22.044 20.0561C22.044 20.2433 22.0224 20.4809 21.9792 20.7689C21.8424 21.5681 21.684 22.3529 21.4896 23.1089C21.1728 24.3401 20.6328 25.2689 19.8552 25.8809C19.0848 26.4857 18.048 26.7809 16.752 26.7809ZM16.9464 24.8369C17.4504 24.8369 17.8752 24.6857 18.228 24.3905C18.588 24.0953 18.8472 23.6417 18.9984 23.0225C19.2072 22.1729 19.3656 21.4385 19.4736 20.8049C19.5096 20.6177 19.5312 20.4233 19.5312 20.2217C19.5312 19.4009 19.1064 18.9905 18.2496 18.9905C17.7456 18.9905 17.3136 19.1417 16.9536 19.4369C16.6008 19.7321 16.3488 20.1857 16.1976 20.8049C16.032 21.4097 15.8736 22.1441 15.708 23.0225C15.672 23.2025 15.6504 23.3897 15.6504 23.5913C15.6432 24.4265 16.0824 24.8369 16.9464 24.8369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6696 26.6512C22.5688 26.6512 22.4968 26.6224 22.4392 26.5576C22.396 26.4856 22.3816 26.4064 22.396 26.3128L24.2608 17.5288C24.2752 17.428 24.3256 17.3488 24.412 17.284C24.4912 17.2192 24.5776 17.1904 24.6712 17.1904H28.264C29.2648 17.1904 30.064 17.3992 30.6688 17.8096C31.2808 18.2272 31.5904 18.8248 31.5904 19.6096C31.5904 19.8328 31.5616 20.0704 31.5112 20.3152C31.288 21.352 30.8344 22.1152 30.1432 22.612C29.4664 23.1088 28.5376 23.3536 27.3568 23.3536H25.5352L24.916 26.3128C24.8944 26.4136 24.8512 26.4928 24.7648 26.5576C24.6856 26.6224 24.5992 26.6512 24.5056 26.6512H22.6696ZM27.4504 21.4888C27.832 21.4888 28.156 21.388 28.4368 21.1792C28.7248 20.9704 28.912 20.6752 29.0056 20.2864C29.0344 20.1352 29.0488 19.9984 29.0488 19.8832C29.0488 19.624 28.9696 19.4224 28.8184 19.2856C28.6672 19.1416 28.4008 19.0696 28.0336 19.0696H26.4136L25.9024 21.4888H27.4504Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5117_22007"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5117_22007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOp);
export default __webpack_public_path__ + "static/media/icOP.54717e52f4c1a877cd3fbed0cf2379dd.svg";
export { ForwardRef as ReactComponent };